var map = {
	"./bindmobile.png": "JBB6",
	"./browsehotactivity.png": "J2Qs",
	"./browseitemdetail.png": "OGgE",
	"./browsemustbuy.png": "aOR2",
	"./buynewuseritem.png": "jp8e",
	"./comment.png": "MnUI",
	"./community_posts.png": "9pL/",
	"./couponBg.png": "j9dK",
	"./firstbuy.png": "N54P",
	"./invitation.png": "EqVW",
	"./invitationuser.png": "jHVU",
	"./left.png": "Hr6t",
	"./luck.gif": "UXhL",
	"./luckDraw.gif": "TvPy",
	"./money.png": "Kq1D",
	"./order.png": "3lAv",
	"./personal.png": "TIUa",
	"./photo.png": "hl7r",
	"./right.png": "matC",
	"./share_item.png": "aW05",
	"./share_order.png": "f9oj",
	"./skintest.png": "lb7m",
	"./thumbsup.png": "Q6BR",
	"./watchlive.png": "IQb4",
	"./wechat.png": "+9Xy"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "t56+";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/integral ^\.\/.*$
// module id = t56+
// module chunks = 1